<template>
    <div class="whole">
        <div class="export flex-align">
            <div class="wrap generate flex-align" v-if="downloadBtnType">
                <i class="el-icon-download" @click="getgenerate" v-if="reportStatus == 0"> 生成个人报告</i>
                <span v-if="reportStatus == 1"> 报告生成中 <i class="el-icon-loading"></i></span>
                <span v-if="reportStatus == 2"><i class="el-icon-success"
                        style="color:#01b78f;margin-right: 5px;"></i>报告已生成</span>
            </div>
            <el-select v-model="whole_termValue" :popper-append-to-body="false" placeholder="请选择" @change="termChange">
                <el-option v-for="(item, index) in whole_termList" :key="index" :label="item.termName" :value="item.key">
                </el-option>
            </el-select>
            <el-select v-model="reportValue" :popper-append-to-body="false" placeholder="请选择" @change="reportChange">
                <el-option v-for="item in reportList" :key="item.type" :label="item.name" :value="item.type">
                </el-option>
            </el-select>
            <el-select v-model="monthValue" :popper-append-to-body="false" placeholder="请选择" @change="monthChange"
                v-if="isMonthReport">
                <el-option v-for="item in monthList" :key="item.defType || item.id" :label="item.name"
                    :value="item.defType != null ? item.defType : item.id">
                </el-option>
            </el-select>
            <el-select v-model="weekValue" placeholder="请选择" @change="weekValTypeChange" v-if="isWeekReport">
                <el-option v-for="item in weekList" :key="item.defType || item.id" :label="item.name"
                    :value="item.defType != null ? item.defType : item.id">
                </el-option>
            </el-select>
            <div class="wrap flex-align" @click="getbatchdownload('btn')" v-if="table_type == 2">
                <img src="../../assets/newReport/export.png" alt="">
                下载报告
            </div>
        </div>
        <div class="bgc">
            <div class="sel">
                <div class="selR flex-align-center">
                    <div class="label1">年级：</div>
                    <el-select v-model="value5" style="margin: 0 20px;" placeholder="请选择" @change="gradeChange">
                        <el-option v-for="item in options1" :key="item.name" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="selR flex-align-center">
                    <div class="label1"> 班级：</div>
                    <el-select v-model="value11" style="margin: 0 20px;" placeholder="请选择" @change="classChange">
                        <el-option v-for="item in options2" :key="item.name" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="selR flex-align-center">
                    <div class="label1 labelX">姓名：</div>
                    <el-input v-model="input" placeholder="输入学生姓名搜索"></el-input>
                    <el-button icon="el-icon-search" @click="getData" style="margin-left: 10px;">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="refresh_condition" style="margin-left: 10px;">重置</el-button>
                </div>
            </div>
            <old_report_whole ref="old_report_whole" v-if="table_type == 1"></old_report_whole>
            <new_report_whole ref="new_report_whole" v-else :preview="isPreview"></new_report_whole>

        </div>
    </div>
</template>

<script>
import old_report_whole from './old_report_whole';
import new_report_whole from './new_report_whole';
import {
    REPORT_MONTH,
    REPORT_WEEK,
    hasSharedTermKey,
    hasSharedReportValue,
    normalizeReportValue,
    getRoutePreferredReportValue,
    pickDefTypeFromList,
    findDefTypeRow,
    buildSharedFiltersPayload,
    buildTeaSharedFiltersPayload,
    getPreferredClassId,
    resolveEmitClassId,
    isUploadRoute,
} from '../newReport/sharedReportFilters';

export default {
    components: {
        old_report_whole,
        new_report_whole
    },
    props: {
        sharedFilters: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            schoolName: '',
            tableData: [],
            loadInfo: '暂无数据',
            userId: [],
            username: [],
            className: [],
            options1: [],
            options2: [],
            value5: [],
            value5_name: '',
            value11: [],
            input: '',
            excellent_add_total: [],
            excellent_minus_total: [],
            good_total: [],
            improve_add_total: [],
            once: true,
            whole_termList: [],
            whole_termValue: '',
            termKey: null,
            currentTerm: '',
            orgId: '',
            teac_Grade_class: '',
            roleType: '',
            schoolIdArr: ['181166', '1176', '181095', '181165', '1172', '181164', '1175', '181097', '1154'],
            table_type: '',
            yanshiId: '',
            term_type: '',
            reportList: [],
            reportValue: null,
            reportType: '',
            monthValue: '',
            monthList: [],
            monthId: '',
            monthName: '',
            account: ['15011591969', '18910941882', '13261203686', '13661102615'],
            downloadBtnType: false,
            reportStatus: 0,
            time: null,
            weekValue: '',
            weekName: '',
            weekList: [],
            isPreview: false,
            classNotFoundNotified: false,
            skipSharedClassOnNextLoad: false,
        };
    },
    computed: {
        routeSchoolId() {
            return this.$route.query.schoolId || this.$route.query.bindId || '';
        },
        isMonthReport() {
            return Number(this.reportValue) === REPORT_MONTH;
        },
        isWeekReport() {
            return Number(this.reportValue) === REPORT_WEEK;
        },
    },
    watch: {
        $route: {
            handler() {
                this.syncPreviewFlagFromRoute();
            },
            immediate: false,
            deep: false
        }
    },
    methods: {
        parsePreviewFlag(val) {
            return val === true || val === 'true' || val === 1 || val === '1';
        },
        syncPreviewFlagFromRoute() {
            const queryPreview = this.$route?.query?.preview;
            const paramsPreview = this.$route?.params?.preview;
            const rawPreview = queryPreview !== undefined ? queryPreview : paramsPreview;
            this.isPreview = this.parsePreviewFlag(rawPreview);
        },
        withPreview(data, options = {}) {
            const ignoreTableType = options.ignoreTableType === true;
            if (!this.isPreview) return data;
            if (ignoreTableType || String(this.table_type) === '2') {
                return { ...data, preview: true };
            }
            return data;
        },
        emitSharedFilters() {
            if (!this.sharedFilters) return;
            const payload = this.isTeaSharedMode()
                ? buildTeaSharedFiltersPayload(
                    this.termKey != null ? this.termKey : this.whole_termValue,
                    this.reportValue,
                    this.monthValue,
                    this.weekValue,
                    resolveEmitClassId(this.value11, this.sharedFilters, this.$route.query),
                    this.sharedFilters
                )
                : buildSharedFiltersPayload(
                    this.termKey != null ? this.termKey : this.whole_termValue,
                    this.reportValue,
                    this.monthValue,
                    this.weekValue,
                    this.sharedFilters
                );
            this.$emit('filters-change', payload);
        },
        isTeaSharedMode() {
            return this.sharedFilters && Object.prototype.hasOwnProperty.call(this.sharedFilters, 'classId');
        },
        getPreferredClassIdForPage() {
            return getPreferredClassId(this.sharedFilters, this.$route.query);
        },
        notifyClassNotFoundOnce() {
            if (this.classNotFoundNotified) return;
            this.classNotFoundNotified = true;
            // this.$message.warning('暂无该班级数据');
        },
        resetClassNotFoundNotify() {
            this.classNotFoundNotified = false;
        },
        handleTeacherClassNotFound() {
            this.notifyClassNotFoundOnce();
            this.options1 = [];
            this.options2 = [];
            this.value5 = '';
            this.value5_name = '';
            this.value11 = '';
            this.setChildTableEmpty();
        },
        buildTeacherGradeOptions() {
            this.options1 = [];
            const seen = {};
            (this.teac_Grade_class || []).forEach(item => {
                if (!seen[item.grade]) {
                    this.options1.push({
                        id: item.grade,
                        orgId: item.orgId,
                        schoolOrgId: item.schoolOrgId,
                        name: this.teac_Grade(item.grade),
                    });
                    seen[item.grade] = true;
                }
            });
        },
        fillTeacherClassOptions(gradeId) {
            this.options2 = [];
            const filteredArray = (this.teac_Grade_class || []).filter(
                obj => Number(obj.grade) === Number(gradeId)
            );
            filteredArray.forEach(item => {
                this.options2.push({
                    id: item.classId,
                    name: item.className,
                });
            });
        },
        applyTeacherClassRow(classRow) {
            this.buildTeacherGradeOptions();
            this.value5 = classRow.grade;
            this.value5_name = this.teac_Grade(classRow.grade);
            const gradeOption = this.options1.find(item => Number(item.id) === Number(classRow.grade));
            this.orgId = this.yanshiId == 459894 ? 6760 : (gradeOption ? gradeOption.schoolOrgId : '');
            this.fillTeacherClassOptions(classRow.grade);
            this.value11 = classRow.classId;
        },
        getPreferredMonthDefType() {
            if (this.sharedFilters && this.sharedFilters.monthDefType != null) {
                return this.sharedFilters.monthDefType;
            }
            const q = this.$route.query;
            if (q.monthValue != null && q.monthValue !== '' && q.monthValue !== 'undefined') {
                return Number(q.monthValue);
            }
            if (q.defType != null && q.defType !== '') {
                return Number(q.defType);
            }
            return null;
        },
        getPreferredWeekDefType() {
            if (this.sharedFilters && this.sharedFilters.weekDefType != null) {
                return this.sharedFilters.weekDefType;
            }
            const q = this.$route.query;
            if (q.weekValue != null && q.weekValue !== '' && q.weekValue !== 'undefined') {
                return Number(q.weekValue);
            }
            if (q.defType != null && q.defType !== '') {
                return Number(q.defType);
            }
            return null;
        },
        applyTermKey(termKey, termList) {
            const index = termList.findIndex(item => item.key == termKey);
            if (index < 0) return false;
            this.whole_termValue = termList[index].key;
            this.termKey = this.whole_termValue;
            this.currentTerm = termList[index].termName;
            this.term_type = termList[index].term;
            return true;
        },
        async loadOrgDataAfterTermReady() {
            if (this.isTeaSharedMode()) {
                await this.getOrgId(this.termKey);
                return;
            }
            const q = this.$route.query;
            if (q.fromType == 'multiRole' && q.type == 'school') {
                await this.getOrgInfoid();
            } else {
                await this.getOrgId(this.termKey);
            }
        },
        clearMonthFields() {
            this.monthList = [];
            this.monthValue = '';
            this.monthId = '';
            this.monthName = '';
        },
        clearWeekFields() {
            this.weekList = [];
            this.weekValue = '';
            this.weekName = '';
        },
        /** 子表 getParentData 最后一参：旧版表始终传 monthValue；新版月测传 month，其它传 week（沿用原逻辑） */
        getExamIdForChildTable() {
            if (String(this.table_type) === '1') {
                return this.monthValue;
            }
            return this.isMonthReport ? this.monthValue : this.weekValue;
        },
        setChildTableEmpty() {
            const oldRef = this.$refs.old_report_whole;
            const newRef = this.$refs.new_report_whole;
            if (String(this.table_type) === '1' && oldRef) {
                oldRef.tableData = [];
            } else if (newRef) {
                newRef.tableData = [];
            }
        },
        /**
         * 已测评的报告类型
         * @param {boolean} applyRouteQuery 为 true 时优先用路由 reportValue、其次 testType（兼容多角色跳转）
         */
        async getReportType(applyRouteQuery = true) {
            const schoolId = this.routeSchoolId;
            const termKey = this.termKey != null && this.termKey !== '' ? this.termKey : this.whole_termValue;
            if (!schoolId || termKey == null || termKey === '') {
                this.reportList = [];
                this.reportValue = null;
                return;
            }
            let data = {
                termKey,
                schoolId,
                classId: '',
            };
            if (this.isPreview) {
                data.preview = true;
            }
            try {
                const resData = await this.$Api.Report.getReportType(data);
                const list = (resData && resData.data) || [];
                if (list.length > 0) {
                    this.reportList = list;
                    const inList = (v) => this.reportList.some(t => Number(t.type) === Number(v));
                    if (applyRouteQuery) {
                        let preferred = null;
                        if (hasSharedReportValue(this.sharedFilters)) {
                            preferred = normalizeReportValue(this.sharedFilters.reportValue);
                        } else {
                            preferred = getRoutePreferredReportValue(this.$route.query);
                        }
                        if (preferred != null && inList(preferred)) {
                            this.reportValue = preferred;
                        } else if (this.reportValue != null && inList(this.reportValue)) {
                            // 保持当前
                        } else {
                            this.reportValue = this.reportList[0].type;
                        }
                    } else if (!inList(this.reportValue)) {
                        this.reportValue = this.reportList[0].type;
                    }
                } else {
                    this.reportList = [];
                    this.reportValue = null;
                }
            } catch (e) {
                this.reportList = [];
                this.reportValue = null;
            }
        },
        async getOrgId(val) {
            const data = { termKey: val };
            const resData = await this.$Api.Home.queryUserMaxOrg(data);
            const roles = resData.data.roles.map(item => item.id);
            this.yanshiId = resData.data.userId;
            const hasTwo = roles.includes(2);
            const hasThree = roles.includes(3);
            // 教师 Tab 传入 teaSharedReportFilters 时，固定走教师班级逻辑
            if (this.isTeaSharedMode()) {
                this.roleType = 2;
                await this.getTeacherClass(val);
                return;
            }
            if (hasTwo && hasThree) {
                this.roleType = 3;
                await this.getOrgInfoid();
            } else if (hasTwo) {
                this.roleType = 2;
                await this.getTeacherClass(val);
            } else if (hasThree) {
                this.roleType = 3;
                await this.getOrgInfoid();
            }
        },
        async getGradeList() {
            let data = {
                orgId: this.orgId,
                termKey: this.termKey,
                schoolId: this.routeSchoolId,
            };
            data = this.withPreview(data);
            const resData = await this.$Api.DataScreen.getGradeList(data);
            this.options1 = resData.data;
            if (this.options1.length !== 0) {
                this.value5 = this.options1[0].id;
                this.value5_name = this.options1[0].name;
                this.getClassList();
            }
        },
        async getClassList() {
            let data = {
                orgId: this.orgId,
                gradeId: this.value5,
                schoolId: this.routeSchoolId,
                termKey: this.termKey,
            };
            data = this.withPreview(data);
            const resData = await this.$Api.DataScreen.getClassList(data);
            this.options2 = resData.data;
            if (this.options2.length !== 0) {
                this.value11 = resData.data[0].id;
                this.getData();
            }
        },
        getData() {
            if (this.reportValue == null) {
                return;
            }
            if (this.roleType == 2 && (this.value11 == null || this.value11 === '')) {
                this.setChildTableEmpty();
                return;
            }
            if (this.isMonthReport && this.monthList.length === 0) {
                this.setChildTableEmpty();
                return;
            }
            const examId = this.getExamIdForChildTable();
            const parentArgs = [
                this.orgId, this.termKey, this.roleType, this.value5, this.value5_name, this.value11,
                this.input, this.whole_termValue, this.currentTerm, this.table_type, this.reportValue, examId
            ];
            this.$nextTick(() => {
                if (String(this.table_type) === '1') {
                    this.$refs.old_report_whole.getParentData(...parentArgs);
                } else {
                    this.$refs.new_report_whole.getParentData(...parentArgs);
                }
            });
        },
        async getIsNewDIm() {
            if (this.reportValue == null) {
                return;
            }
            let data = {
                termKey: this.termKey,
                schoolId: this.routeSchoolId,
                examType: this.reportValue
            };
            data = this.withPreview(data, { ignoreTableType: true });
            const resData = await this.$Api.DataScreen.getIsNewDIm(data);
            this.table_type = resData.data;
            if (this.isMonthReport) {
                await this.getMonthTestList();
            } else if (this.isWeekReport) {
                this.table_type = 2;
                await this.weekParticipation();
            }
        },
        gradeChange(val) {
            const index = this.options1.findIndex(item => item.id == val);
            this.value5_name = this.options1[index].name;
            if (this.roleType == 2) {
                this.options2 = [];
                this.orgId = '';
                this.value11 = '';
                const targetObject = this.options1.find(obj => obj.id === val);
                this.orgId = this.yanshiId == 459894 ? 6760 : targetObject.schoolOrgId;
                const filteredArray = this.teac_Grade_class.filter(
                    obj => Number(obj.grade) === Number(val)
                );
                filteredArray.forEach(item => {
                    this.options2.push({
                        id: item.classId,
                        name: item.className,
                    });
                });
                this.value11 = this.options2[0].id;
                this.getData();
            } else {
                this.getClassList();
            }
            if (this.roleType == 2) {
                this.emitSharedFilters();
            }
        },
        classChange() {
            this.getData();
            if (this.roleType == 2) {
                this.emitSharedFilters();
            }
        },
        async refresh_condition() {
            this.input = '';
            if (this.options1.length === 0) {
                return;
            }
            this.value5 = this.options1[0].id;
            this.value5_name = this.options1[0].name;
            if (this.roleType == 2) {
                this.options2 = [];
                this.orgId = this.yanshiId == 459894 ? 6760 : this.options1[0].schoolOrgId;
                const filteredArray = this.teac_Grade_class.filter(
                    obj => Number(obj.grade) === Number(this.value5)
                );
                filteredArray.forEach(item => {
                    this.options2.push({
                        id: item.classId,
                        name: item.className,
                    });
                });
                this.value11 = this.options2.length ? this.options2[0].id : '';
            } else {
                await this.getClassList();
                return;
            }
            this.getData();
        },
        async getTermList() {
            try {
                this.resetClassNotFoundNotify();
                const res = await this.$Api.DataScreen.queryTermList();
                this.whole_termList = res.data;
                const q = this.$route.query;
                if (hasSharedTermKey(this.sharedFilters)) {
                    if (this.applyTermKey(Number(this.sharedFilters.termKey), this.whole_termList)) {
                        await this.getReportType(true);
                        await this.getIsNewDIm();
                        await this.loadOrgDataAfterTermReady();
                        this.emitSharedFilters();
                    }
                } else if (q.source == 'upload' && q.termValue) {
                    if (this.applyTermKey(Number(q.termValue), this.whole_termList)) {
                        await this.getReportType(true);
                        await this.getIsNewDIm();
                        await this.loadOrgDataAfterTermReady();
                        this.emitSharedFilters();
                    }
                } else if (q.fromType == 'multiRole' && q.type == 'school') {
                    if (q.date) {
                        this.whole_termValue = Number(q.date);
                        this.termKey = this.whole_termValue;
                        const index = this.whole_termList.findIndex(item => item.key == Number(q.date));
                        this.currentTerm = this.whole_termList[index].termName;
                        await this.getReportType(true);
                        await this.getIsNewDIm();
                        this.getOrgInfoid();
                        this.emitSharedFilters();
                    }
                } else if (q.fromType == 'multiRole' && q.type == 'class') {
                    this.whole_termValue = Number(q.date);
                    this.termKey = this.whole_termValue;
                    const index = this.whole_termList.findIndex(item => item.key == Number(q.date));
                    this.currentTerm = this.whole_termList[index].termName;
                    await this.getReportType(true);
                    await this.getIsNewDIm();
                    await this.getOrgId(this.termKey);
                    this.emitSharedFilters();
                } else {
                    this.whole_termValue = this.whole_termList[0].key;
                    this.termKey = this.whole_termValue;
                    this.currentTerm = this.whole_termList[0].termName;
                    this.term_type = this.whole_termList[0].term;
                    await this.getReportType(true);
                    await this.getIsNewDIm();
                    await this.getOrgId(this.termKey);
                    this.emitSharedFilters();
                }
            } catch (err) {
                console.log('err:', err);
            }
        },
        async termChange(val) {
            this.resetClassNotFoundNotify();
            this.skipSharedClassOnNextLoad = true;
            this.options1 = [];
            this.value5 = '';
            this.options2 = [];
            this.value11 = '';
            this.termKey = val;
            this.whole_termValue = val;
            this.tableData = [];
            const index = this.whole_termList.findIndex(item => item.key == val);
            this.currentTerm = this.whole_termList[index].termName;
            this.term_type = this.whole_termList[index].term;
            this.clearMonthFields();
            this.clearWeekFields();
            await this.getReportType(false);
            await this.getIsNewDIm();
            await this.loadOrgDataAfterTermReady();
            this.emitSharedFilters();
        },
        async getTeacherClass(val) {
            let data = {
                termKey: val,
                // schoolId: this.routeSchoolId,
            };
            if (this.$route.query.fromType == 'multiRole' && this.$route.query.type == 'class') {
                data.schoolId = this.routeSchoolId
            }
            data = this.withPreview(data);
            const resData = await this.$Api.Report.getTeacherClass(data);
            this.teac_Grade_class = resData.data || [];
            this.options1 = [];
            this.options2 = [];

            if (this.teac_Grade_class.length === 0) {
                this.handleTeacherClassNotFound();
                if (this.isTeaSharedMode()) {
                    this.emitSharedFilters();
                }
                return;
            }

            const applySharedClass = this.isTeaSharedMode() && !this.skipSharedClassOnNextLoad;
            this.skipSharedClassOnNextLoad = false;
            const preferredClassId = applySharedClass ? this.getPreferredClassIdForPage() : null;

            if (preferredClassId != null) {
                const classRow = this.teac_Grade_class.find(
                    item => Number(item.classId) === Number(preferredClassId)
                );
                if (classRow) {
                    this.applyTeacherClassRow(classRow);
                    this.getData();
                    this.emitSharedFilters();
                    return;
                }
                this.handleTeacherClassNotFound();
                this.emitSharedFilters();
                return;
            }

            this.buildTeacherGradeOptions();
            if (this.options1.length === 0) {
                this.handleTeacherClassNotFound();
                return;
            }
            this.orgId = this.yanshiId == 459894 ? 6760 : this.options1[0].schoolOrgId;
            this.value5 = this.options1[0].id;
            this.value5_name = this.options1[0].name;
            this.fillTeacherClassOptions(this.value5);
            this.value11 = this.options2.length ? this.options2[0].id : '';
            if (this.value11) {
                this.getData();
            } else {
                this.setChildTableEmpty();
            }
            if (this.isTeaSharedMode()) {
                this.emitSharedFilters();
            }
        },
        teac_Grade(id) {
            const Gradelist = {
                '1': '一年级',
                '2': '二年级',
                '3': '三年级',
                '4': '四年级',
                '5': '五年级',
                '6': '六年级',
            };
            return Gradelist[id];
        },
        hide_school() {
            const sid = this.$route.query.schoolId;
            return this.schoolIdArr.includes(sid) && this.termKey == '20232';
        },
        async getOrgInfoid() {
            let data = {
                bindId: this.$route.query.schoolId,
                level: 5,
                termKey: this.termKey
            };
            data = this.withPreview(data);
            const resData = await this.$Api.DataScreen.getOrgInfo(data);
            this.orgId = this.yanshiId == 459894 ? 6760 : resData.data.id;
            this.getGradeList();
        },
        async reportChange(val) {
            if (val != REPORT_MONTH) {
                this.clearMonthFields();
            }
            if (val != REPORT_WEEK) {
                this.clearWeekFields();
            }
            await this.getIsNewDIm();
            if (val != REPORT_MONTH && val != REPORT_WEEK) {
                this.getData();
            }
            this.emitSharedFilters();
        },
        monthChange(val) {
            this.monthValue = val;
            const row = findDefTypeRow(this.monthList, val);
            if (row) this.monthName = row.name;
            this.getData();
            this.emitSharedFilters();
        },
        async getMonthTestList() {
            this.monthList = [];
            this.monthValue = '';
            let data = {
                schoolId: this.routeSchoolId,
                termKey: this.whole_termValue,
                examType: REPORT_MONTH,
            };
            data = this.withPreview(data);
            try {
                const res = await this.$Api.Report.getparticipationMonth(data);
                if (res.data.length !== 0) {
                    this.monthList = res.data;
                    this.monthValue = pickDefTypeFromList(this.monthList, this.getPreferredMonthDefType());
                    const row = findDefTypeRow(this.monthList, this.monthValue);
                    this.monthName = row ? row.name : '';
                    this.getData();
                    this.emitSharedFilters();
                } else {
                    this.setChildTableEmpty();
                }
            } catch (e) {
                this.setChildTableEmpty();
            }
        },
        async getbatchdownload(type) {
            let data = {
                schoolId: this.routeSchoolId,
                termIndex: this.whole_termValue,
                examType: this.reportValue,
                examId: this.reportValue == REPORT_MONTH ? this.monthValue : this.weekValue,
                version: 2,
                batch: true
            };
            data = this.withPreview(data);
            const resData = await this.$Api.Report.getbatchdownload(data);
            if (resData.data != null) {
                this.reportStatus = 2;
                if (this.time) {
                    clearInterval(this.time);
                }
                if (type == 'btn') window.open(resData.data);
            } else if (type == 'btn') {
                this.$message({
                    message: '报告生成中',
                    center: true,
                    offset: 70,
                });
            }
        },
        async getgenerate() {
            let data = {
                schoolId: this.routeSchoolId,
                termIndex: this.whole_termValue,
                examType: this.reportValue,
                examId: this.reportValue == REPORT_MONTH ? this.monthValue : this.weekValue,
                version: 2,
                batch: true
            };
            data = this.withPreview(data);
            const resData = await this.$Api.Report.getgenerate(data);
            if (resData.code == 200) {
                this.reportStatus = 1;
                this.time = setInterval(() => {
                    this.getbatchdownload('polling');
                }, 5000);
            }
        },
        async weekParticipation() {
            this.weekList = [];
            this.weekValue = '';
            let data = {
                schoolId: this.routeSchoolId,
                termKey: this.whole_termValue,
                examType: REPORT_WEEK,
            };
            data = this.withPreview(data);
            const resData = await this.$Api.Report.getparticipationWeek(data);
            if (resData.data.length !== 0) {
                this.weekList = resData.data;
                this.weekValue = pickDefTypeFromList(this.weekList, this.getPreferredWeekDefType());
                const row = findDefTypeRow(this.weekList, this.weekValue);
                this.weekName = row ? row.name : '';
                this.getData();
                this.emitSharedFilters();
            } else {
                this.setChildTableEmpty();
            }
        },
        weekValTypeChange(val) {
            this.weekValue = val;
            const value = findDefTypeRow(this.weekList, val);
            if (value) this.weekName = value.name;
            this.getData();
            this.emitSharedFilters();
        }
    },
    mounted() {
        this.syncPreviewFlagFromRoute();
        this.getTermList();
        this.schoolName = this.$route.query.schoolName;
        this.downloadBtnType = this.account.includes(sessionStorage.getItem('name'));
    },
};
</script>
<style lang="less" scoped>
@import url("./less/report_whole.less");
</style>
